import { Controller } from "@hotwired/stimulus";

// Minimal copy-to-clipboard for marketing waitlist (no icon targets).
export default class extends Controller {
  static values = { text: String };

  async copy() {
    if (!this.originalLabel) this.originalLabel = this.element.textContent.trim();
    try {
      await navigator.clipboard.writeText(this.textValue);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = this.textValue;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    this.element.textContent = "Copied!";
    setTimeout(() => {
      this.element.textContent = this.originalLabel;
    }, 2000);
  }
}
